import React from 'react';
import { useNavigate } from 'react-router-dom';

const categories = [
  { name: 'Taxi & Transportation', icon: '/car.svg' },
  { name: 'Education', icon: '/education.svg' },
  { name: 'Delivery', icon: '/delivery.svg' },
  { name: 'Fitness', icon: '/fitness.svg' },
  { name: 'Rental', icon: '/rent.png' },
  { name: 'Consultation', icon: '/consultation.svg' },
  { name: 'E-commerce', icon: '/ecommerce.svg' },
  { name: 'Freelancer', icon: '/freelancer.png' },
  { name: 'Social Platform', icon: '/social.png' },
  { name: 'Real Estate', icon: '/real.png' },
];

const CategoryGrid = () => {
  const navigate = useNavigate();

  const handleClick = (categoryName) => {
    navigate(`/checkOutForm?businessType=${encodeURIComponent(categoryName)}`);
  };

  return (
    <div className="bg-black min-h-screen flex flex-col gap-10 items-center justify-center px-6">
      <h1 className="lg:text-5xl text-3xl text-white font-bold text-center">
        Services Provided To
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 max-w-6xl w-full">
        {categories.map((category, index) => (
          <button
            key={index}
            onClick={() => handleClick(category.name)}
            className="
              group relative flex flex-col items-center justify-center
              p-6 rounded-lg shadow-md
              bg-[#171717] font-semibold
              transition-all duration-300 ease-in-out
              hover:scale-105
              overflow-hidden
            "
          >
            {/* Hover gradient background */}
            <span
              className="
                absolute inset-0 opacity-0 group-hover:opacity-100
                bg-[linear-gradient(90deg,#fdfefe_5%,#7acdeb_70%,rgba(0,105,217,0.8))]
                bg-[length:200%_200%]
                animate-[gradientMove_4s_ease_infinite]
                transition-opacity duration-300
                rounded-lg
                -z-10
              "
            ></span>

            {/* Icon (white → black on hover) */}
            <img
              src={category.icon}
              alt={category.name}
              className="
                w-10 h-10 mb-3 z-10 transition-all duration-300 
                filter invert brightness-0 group-hover:invert-0 group-hover:black
              "
            />

            {/* Text (white → black on hover) */}
            <div
              className="
                text-lg z-10 text-white transition-colors duration-300 
                group-hover:text-black
              "
            >
              {category.name}
            </div>
          </button>
        ))}
      </div>

      {/* Gradient animation keyframes */}
      <style>
        {`
          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
    </div>
  );
};

export default CategoryGrid;
